module.exports = __webpack_public_path__ + "img/quest_icon_0057_location.0671157e.png";